import Menu, { MenuProps } from '@material-ui/core/Menu';
import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import React, { FC } from 'react';

/**
 * @internal
 */
const StyledMenu: FC<MenuProps> = props => (
  <Menu
    ref={props.ref}
    anchorOrigin={{
      horizontal: 'left',
      vertical: 'bottom',
    }}
    elevation={0}
    getContentAnchorEl={null}
    {...props}
  />
);

/**
 * @internal
 */
export default withStyles((theme: Theme) =>
  createStyles({
    list: {
      minWidth: 242,
    },
    paper: {
      border: theme.customBorders.gray300,
      borderRadius: theme.misc.borderRadius,
      boxShadow: theme.customShadows.shadow4,
    },
  }),
)(StyledMenu);
